module.exports = __webpack_public_path__ + "img/En_window.382bc3e6.png";